
import CreateView from '@/components/CreateView';
import { debounce } from 'throttle-debounce';

export default {
  // 创建页面
  name: 'XrCreate',
  components: {
    CreateView: CreateView
  },
  props: {
    title: String,
    loading: Boolean,
    appendToBody: {
      type: Boolean,
      default: true
    },
    showCancel: {
      type: Boolean,
      default: true
    },
    showConfirm: {
      type: Boolean,
      default: true
    },
    confirmButtonText: {
      type: String,
      default: '保存'
    }
  },
  data: function data() {
    return {};
  },

  computed: {},
  watch: {},
  created: function created() {
    this.debouncedSaveField = debounce(300, this.save);
  },
  mounted: function mounted() {
    if (this.appendToBody) {
      document.body.appendChild(this.$el);
    }
  },
  destroyed: function destroyed() {
    if (this.appendToBody) {
      if (this.$el && this.$el.parentNode) {
        this.$el.parentNode.removeChild(this.$el);
      }
    }
  },

  methods: {
    afterEnter: function afterEnter() {
      this.$emit('afterEnter');
    },
    save: function save() {
      this.$emit('save');
    },
    close: function close() {
      this.$emit('close');
    }
  }
};